let message = require('./message');
let ent = require('ent');

function getTeamLink(team, options) {
    let safeString = '';
    if (team.teamPage) {
        let result = ent.decode(team.title);
        options.hash.CATEGORY = result;
        let linguaString = message('careers.requisition.team.link', options);
        safeString = `<p><a href="/careers/openings?category=${
            team.id
        }">${linguaString}</a></p>`;
    }

    return safeString;
}

module.exports = getTeamLink;
